module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_int_02_6DE79_1SF_HND.74428aab.jpg";